<template>
  <transition name="slide" @after-leave="afterLeave">
    <div v-if="show" class="toast-wrap">
      <div
        :class="componentClass"
        @click="clickHandle"
      >
        <icon
          v-if="type === 'loading'"
          class="icon rotate"
          name="i-loading"
          :color="'#fff'"
        ></icon>
        <icon
          v-if="type === 'error'"
          class="icon"
          name="i-close"
          :color="'#fff'"
        ></icon>
        <div>{{ content }}</div>
      </div>
      <div v-if="type === 'loading'" class="mask"></div>
    </div>
  </transition>
</template>

<script>
import Icon from '@/_components/icon/icon.vue'

export default {
  name: 'Toast',
  components: {
    Icon
  },
  data() {
    return {
      show: false,
      content: '',
      time: 2000,
      type: 'default',
      callback: null,
      clickHide: true,
      autoDestroy: false
    }
  },
  mounted() {
    document.body.appendChild(this.$el)
    if (this.time) {
      setTimeout(this.close, this.time)
    }
  },
  beforeDestroy() {
    document.body.removeChild(this.$el)
    if (this.callback) {
      this.$nextTick(() => {
        this.callback()
      })
    }
  },
  destroyed() {
    this.$emit('destroyed')
  },
  computed: {
    componentClass() {
      return [
        'toast',
        `toast-${this.type}`
      ]
    }
  },
  methods: {
    clickHandle() {
      if (this.clickHide && this.type !== 'loading') {
        this.close()
      }
    },
    close() {
      this.show = false
    },
    afterLeave() {
      if (this.autoDestroy) {
        this.$destroy()
      }
    }
  }
}
</script>

<style scoped>
  .toast-wrap { position: fixed; z-index: 1000; left: 0; top: 0; }
  .toast { display: flex; flex-direction: column; justify-content: center; align-items: center; text-align: center; position: fixed; bottom: 5rem; left: 50%; font-size: 1.17rem; padding: 0.67rem 1.25rem; overflow: hidden; opacity: .9; border-radius: 2rem; min-width: 5rem; max-width: 60%; word-break: break-all; box-shadow: 1px 1px 2px 1px rgba(0, 0, 0, .16); transform: translate(-50%, 0); z-index: 1000; }
  .toast-default { color: #fff; background-color: #232323; }
  .toast-loading { padding: 1.67rem; border-radius: 0.83rem; bottom: 50%; transform: translate(-50%, 50%); color: #fff; background-color: #232323; }
  .toast-loading .icon { width: 30px; height: 30px; }
  .toast-error { padding: 1.67rem 1.25rem; border-radius: 0.83rem; bottom: 50%; transform: translate(-50%, 50%); opacity: .7; color: #fff; background-color: #232323; }
  .toast-error .icon { margin-bottom: 0.83rem; width: 30px; height: 30px; }
  .mask { position: fixed; left: 0; top: 0; width: 100vw; height: 100vh; z-index: 500; }
  .slide-enter-active, .slide-leave-active { transition: all .3s }
  .slide-enter, .slide-leave-to { opacity: 0 }
  .rotate { animation: rotate 1.5s infinite linear; }
  @keyframes rotate {
    form {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>



// WEBPACK FOOTER //
// toast.vue?7dba0829